

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"46","height":"45","xmlns":"http://www.w3.org/2000/svg"}, rest), [h('g', {"fill":"none","fill-rule":"evenodd"}, [h('ellipse', {"fill":"#FFF","cx":"22.535","cy":"22.468","rx":"22.535","ry":"22.468"}, []), h('path', {"d":"M18.81 24.376l7.886-7.886 1.314 1.314-7.886 7.886-1.314-1.314zm-4.82 7.476a.949.949 0 11-1.342-1.342l1.14-1.14 1.342 1.342-1.14 1.14zm19.208-20.881l-6.307-.001a.332.332 0 00-.235.097L15.911 21.813l-1.356-1.356-1.355 1.355 2.71 2.711-4.538 4.54a2.875 2.875 0 104.065 4.065l4.54-4.54 2.71 2.712 1.355-1.355-1.356-1.356 10.745-10.746a.332.332 0 00.097-.235l.002-6.305a.332.332 0 00-.332-.332z","fill":"#003E99"}, [])])]);
};

        